import React, { Component } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'

import { logout } from '../../../store/entities/user'
import { clearAllEvents } from '../../../store/entities/events'
import { globalViewText, isGlobalView, superFeedViewText, allowedOptionsSuperFeed, isSuperFeedView , isCredentialMonitoringEnabled} from '../../../utilities/config'

import profileSvg from '../../../assets/profile.svg'
import profileSelectedSvg from '../../../assets/profile_selected.svg'
import groupSvg from '../../../assets/group.svg'
import settingsSvg from '../../../assets/settings.svg'
import logoutSvg from '../../../assets/logout.svg'
import peopleSvg from '../../../assets/people-black.svg'
import deployLogo from '../../../assets/deploy-Icon.svg'
import visible from '../../../assets/zoom.svg'
import socSvg from '../../../assets/soc.svg'
import alarmSvg from '../../../assets/alarm.svg'
import statusSvg from '../../../assets/status.svg'
import './profilePopover.scss'
import { GLOBAL_VIEW_DISABLED_OPTIONS, GLOBAL_VIEW_DISABLED_MESSAGE, GLOBAL_VIEW_DISABLED_PATHS } from '../../../utilities/globalViewDisabled'
import { SUPER_FEED_DISABLED_OPTIONS, SUPER_FEED_DISABLED_MESSAGE } from '../../../utilities/superFeedViewDisabled'
import { 
  THREAT_INTEL_CUST_LICENSE_CODE, 
  BASIC_PROT_CUST_LICENSE_CODE, 
  PHISH_PROT_SUITE_CUST_LICENSE_CODE,  
  THREAT_INTEL_CUST_AVAILABLE_OPTIONS, 
  THREAT_INTEL_DISABLED_MESSAGE,
  BASIC_PROT_DISABLED_MESSAGE
} from '../../../utilities/threatIntelCustomerUtils'

class ProfilePopover extends Component {
  state = {
    contentClass: ['profile-popover', 'profile-popover-remove'],
    isOpened: false,
  }

  profileOptions = [
    {
      name: 'Threat Feed',
      icon: visible,
      handleClick: () =>
        this.props.history.push({
          pathname: this.getFeedPath(),
      }),
    },
    {
      name: 'SOC Integration',
      icon: socSvg,
      handleClick: () =>
        this.props.history.push({
          pathname: `/soc-integration`,
          state: { tab: 'soc integration' },
        }),
    },
    {
      name: 'Deployment',
      icon: deployLogo,
      handleClick: () =>
        this.props.history.push({
          pathname: `/${
            isGlobalView(this.props.selectedCustomer.organizationName)
              ? 'tenants'
              : 'customers'
          }/${this.props.selectedCustomer.id}/deployment`,
          state: { tab: 'deployment' },
        }),
    },
    {
      name: 'License Management',
      icon: groupSvg,
      handleClick: () =>
        this.props.history.push({
          pathname: `/${
            isGlobalView(this.props.selectedCustomer.organizationName)
              ? 'tenants'
              : 'customers'
          }/${this.props.selectedCustomer.id}/license-management`,
          state: { tab: 'License Management' },
        }),
    },
    {
      name: 'Settings',
      icon: settingsSvg,
      handleClick: () =>
        this.props.history.push(
          `/customers/${this.props.selectedCustomer.id}/settings`,
        ),
    },
    {
      name: 'Threat Intelligence',
      icon: socSvg,
      handleClick: () =>
        this.props.history.push({
          pathname: `/threat-intel`,
          state: { tab: 'threat intel' },
        }),
    },

    {
      name: 'Logout',
      icon: logoutSvg,
      handleClick: () => {
        this.props.clearAllEvents()
        this.props.logout()
        //window.location.replace(`${process.env.REACT_APP_LOGIN_WINDOW_URL}`)
      },
    },

  ]

  constructor(props) {
    super(props)
    this.updateWrapperRef = React.createRef()
  }

  toggleGlobalViewSettings = () => {
    const { orgList, selectedCustomer } = this.props;
    // check if organization list has 'Global view' in it
    const hasGlobalView = orgList.some(item => item.organizationName === globalViewText);
    const isSuperFeedView = selectedCustomer.organizationName === superFeedViewText;
    if (hasGlobalView) {
      let isGlobal = isGlobalView(selectedCustomer.organizationName);
      const { multiGroup } = selectedCustomer;
      this.profileOptions.forEach((item) => {
        const isLicenseOrSoc = ['License Management', 'SOC Integration', 'Threat Intelligence'].includes(item.name);
        item.isDisabled = isGlobal && GLOBAL_VIEW_DISABLED_OPTIONS.includes(item.name) || (isLicenseOrSoc && multiGroup);
        item.tooltip = item.isDisabled ? `${GLOBAL_VIEW_DISABLED_MESSAGE} ${item.name}` : '';
      });
    }

    if (isSuperFeedView) {
      this.profileOptions.forEach((item) => {
        if(SUPER_FEED_DISABLED_OPTIONS.includes(item.name)) {
          item.isDisabled = true;
          item.tooltip = `${SUPER_FEED_DISABLED_MESSAGE} ${item.name}`;
        }
      });
    }
    this.updateMenuLicenseOptions();
  }

  getFeedPath = () => {
    if(isSuperFeedView(this.props.selectedCustomer.organizationName)) {
      return `/super-feed`;
    }
    else {
      return `/${isGlobalView(this.props.selectedCustomer.organizationName) ? 'tenants': 'customers'}/${this.props.selectedCustomer.id}/incidents`;
    }
  }

  componentDidMount() {
    if (this.props.userRole === 'TenantAdmin') {
      this.profileOptions.splice(0, 0, {
        name: 'MSP Center',
        icon: peopleSvg,
        handleClick: () => this.props.history.push(`/tenant-admin`),
      })
      this.profileOptions.join()
    }

    if(this.props.userRole == 'PixmAdmin'){
      this.profileOptions.splice(5, 0 ,
        {
          name: 'Advanced Settings',
          icon: settingsSvg,
          handleClick: () => {
            this.props.history.push(`/advanced-settings`)
          },
        })
      this.profileOptions.splice(6, 0 ,
        {
          name: 'Threat Intelligence Feed',
          icon: visible,
          handleClick: () => this.props.history.push({pathname: '/threat-intel-feed'})
        },)
      // Policy Violations (PIXMC-6225) is visible to Pixm Admin (PA) only, same as
      // Threat Intelligence Feed and Governance either side of it.
      this.profileOptions.splice(7, 0 ,
        {
          name: 'Policy Violations',
          icon: alarmSvg,
          handleClick: () => this.props.history.push(`/customers/${this.props.selectedCustomer.id}/policy-violations`),
        },)
      // Governance (Data Controls) is visible to Pixm Admin (PA) only.
      this.profileOptions.splice(8, 0 ,
        {
          name: 'Governance',
          icon: settingsSvg,
          handleClick: () => this.props.history.push(`/customers/${this.props.selectedCustomer.id}/governance`),
        },)
      // Incident Feed (PIXMC-6521) is Pixm Admin (PA) only, like the items above it. It is
      // inserted at index 0 so it is the FIRST menu entry, above Threat Feed.
      //
      // ⚠️ This is the LAST of the PA splices — every fixed-index splice at 5–8 has already
      // run — so inserting at 0 simply shifts the existing entries down by one (their relative
      // order is preserved) and does NOT disturb those earlier splices. The later helpers
      // (pushThreatIntelligence / pushCredentialMonitoring) splice at length-1, so they are
      // unaffected too. Any PA splice added AFTER this one must account for the leading
      // Incident Feed entry.
      this.profileOptions.splice(0, 0 ,
        {
          name: 'Incident Feed',
          icon: statusSvg,
          // Available in Global View too (both endpoints support r=M), hence the
          // tenants/customers branch — same shape as Deployment and License Management,
          // and unlike Governance / Policy Violations which are customer-only.
          handleClick: () => this.props.history.push(`/${
            isGlobalView(this.props.selectedCustomer.organizationName)
              ? 'tenants'
              : 'customers'
          }/${this.props.selectedCustomer.id}/incident-feed/overview`),
        },)
      this.profileOptions.join()
    }
    this.updateMenuLicenseOptions();
      
  }

  toggleCredentialMonitoringOption = () => {
    if(this.props.selectedCustomer && isCredentialMonitoringEnabled(this.props.selectedCustomer)){
      if(!this.profileOptions.find(item => item.name === 'Credential Monitoring')) {
        this.pushCredentialMonitoring(this.profileOptions);
      }
    } else {
      this.profileOptions = this.profileOptions.filter(item => item.name !== 'Credential Monitoring');
    }
  }

  pushThreatIntelligence = (profileOptions) => {

    // Add Threat Intelligence option before Logout option

    profileOptions.splice(profileOptions.length - 1, 0, {
      name: 'Threat Intelligence',
      icon: socSvg,
      handleClick: () =>
        this.props.history.push({
          pathname: `/threat-intel`,
          state: { tab: 'threat intel' },
        }),
    });

    return profileOptions;
  }

  pushCredentialMonitoring = (profileOptions) => {
    // Add Credential Monitoring option before Logout option

    if(this.props.userRole === 'PixmAdmin'){
      profileOptions.splice(profileOptions.length - 1, 0, {
      name: 'Credential Monitoring',
      icon: groupSvg,
      handleClick: () =>
        this.props.history.push({
          pathname: `/customers/${this.props.selectedCustomer.id}/risk-profiles`,
        }),
    });
    }
  }

  componentDidUpdate(prevProps) {
    const { selectedCustomer } = this.props;
    if (selectedCustomer && selectedCustomer !== prevProps.selectedCustomer) {
      this.toggleGlobalViewSettings();
      this.toggleCredentialMonitoringOption();
    }
  }

  toggle = () => {
    let { contentClass, isOpened } = this.state
    if (contentClass.indexOf('profile-popover-remove') === -1) {
      contentClass.push('profile-popover-remove')
      isOpened = false
    } else {
      contentClass.pop()
      isOpened = true
    }
    this.setState({ contentClass, isOpened })
  }

  handleClickOutside = (event) => {
    let { contentClass, isOpened } = this.state
    if (contentClass.indexOf('profile-popover-remove') === -1) {
      contentClass.push('profile-popover-remove')
      isOpened = false
    }
    this.setState({ contentClass, isOpened })
  }

  updateMenuLicenseOptions = () => {
    if((this.props.userRole === "PixmAdmin" || this.props.userRole === "TenantAdmin") && this.props.licenseType){
      switch(this.props.licenseType) {
        case THREAT_INTEL_CUST_LICENSE_CODE:
          // Only keep options that are part of THREAT_INTEL_CUST_AVAILABLE_OPTIONS
          this.profileOptions.forEach(item => {
            item.isDisabled = item.isDisabled || !THREAT_INTEL_CUST_AVAILABLE_OPTIONS.includes(item.name);
            item.tooltip = item.isDisabled ? `${item.tooltip || THREAT_INTEL_DISABLED_MESSAGE}` : '';
          });

          if(!this.profileOptions.find(item => item.name === 'Threat Intelligence')) {
            this.profileOptions = this.pushThreatIntelligence(this.profileOptions);
          }
          break;
        case BASIC_PROT_CUST_LICENSE_CODE:
          // Disable Threat Intelligence for Basic Protection Customers
          this.profileOptions = this.profileOptions.filter(item => item.name !== 'Threat Intelligence');
          break;
        case PHISH_PROT_SUITE_CUST_LICENSE_CODE:
          // Disable nothing for Phishing Protection Suite Customers
          if(!this.profileOptions.find(item => item.name === 'Threat Intelligence')) {
            this.profileOptions = this.pushThreatIntelligence(this.profileOptions);
          }
          break;
        default:
          break;
      }
    }

    if(this.props.userRole === 'CustomerAdmin' && this.props.licenseType){
      // Only keep options that are part of THREAT_INTEL_CUST_AVAILABLE_OPTIONS
      switch(this.props.licenseType) {
      case THREAT_INTEL_CUST_LICENSE_CODE:
          this.profileOptions = this.profileOptions.filter(item => THREAT_INTEL_CUST_AVAILABLE_OPTIONS.includes(item.name));
          break;
      case BASIC_PROT_CUST_LICENSE_CODE:
          // Disable Threat Intelligence for Basic Protection Customers
          this.profileOptions = this.profileOptions.filter(item => item.name !== 'Threat Intelligence');
          break;
      case PHISH_PROT_SUITE_CUST_LICENSE_CODE:
          // Disable nothing for Phishing Protection Suite Customers
      default:
          break;
      }
    }

  }

  render() {
    let preventClick = true
    if (this.props.selectedCustomer) {
      preventClick = false
    }
    return (
      <div
        className={'parent'}
        onClick={() => this.toggle()}
        tabIndex="0"
        onBlur={(e) => this.handleClickOutside(e)}
        style={{
          marginRight: '5px',
          padding: '3px',
          borderRadius: '50%',
          background: this.state.isOpened ? '#2d5fa7' : '#f7f7f7',
          cursor: 'pointer',
        }}
      >
        <img
          src={this.state.isOpened ? profileSelectedSvg : profileSvg}
          alt=""
          style={{ height: '30px' }}
          srcSet=""
        />

        <div className={this.state.contentClass.join(' ')}>
          <div className="popover-arrow"></div>
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              padding: '10px',
              fontSize: '14px',
              fontFamily: 'Roboto',
            }}
          >
            {this.profileOptions.map((item) => (
              <div
                key={item.name}
                disabled={item.disabled}
                className="profile-option"
                onClick={() =>
                  (!preventClick || item.name === 'Logout') && !item.isDisabled
                    ? item.handleClick()
                    : null
                }
              >
                <div
                  style={{ padding: '5px', width: '15%' }}
                  title={item.tooltip}
                  className={item.isDisabled ? 'option-disabled' : null}
                >
                  <img src={item.icon} height="20px" alt="" srcSet="" />
                </div>
                <div
                  style={{ flexGrow: '1', padding: '5px' }}
                  title={item.tooltip}
                  className={item.isDisabled ? 'option-disabled' : null}
                >
                  {item.name}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
      // <Dropdown>
      //   <Dropdown.Toggle
      //     bsPrefix="toggle"
      //     as={Link}
      //     to="#!"
      //     className="pe-3 ps-2 nav-link"
      //   >
      //     <img src={profileSvg} alt="" style={{ height: '20px' }} srcSet="" />
      //   </Dropdown.Toggle>
      //   <Dropdown.Menu className="dropdown-caret dropdown-menu-card  dropdown-menu-end">
      //     <div className="bg-white rounded-2 py-2 dark__bg-1000">
      //     {this.profileOptions.map((item) => (
      //       <>
      //         <div data-tip data-for={item.name}>
      //           <Dropdown.Item
      //             key={item.name}
      //             onClick={() => (!preventClick || item.name === 'Logout') && !item.isDisabled ?  item.handleClick() : null}
      //             disabled={item.isDisabled}
      //           >{item.name}</Dropdown.Item>
      //         </div>
      //         {item.isDisabled &&
      //             <Tooltip id={item.name} data={item.tooltip} />
      //         }
      //       </>
      //     ))}
      //     </div>
      //   </Dropdown.Menu>
      // </Dropdown>
    )
  }
}

const mapStateToProps = (state) => ({
  selectedCustomer: state.entities.customers.selected,
  userRole: state.entities.user.roles,
  orgList: state.entities.customers.list,
  licenseType: state.entities.customers.selected?.licenseType
})

const mapDispatchToProps = (dispatch) => ({
  logout: () => dispatch(logout()),
  clearAllEvents: () => dispatch(clearAllEvents()),
})

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(ProfilePopover),
)
